/** Volume gauge thumb (Figma 1155:605) */
const GaugeThumb = ({ percent = 0.53 }) => (
  <svg
    width="19"
    height="19"
    viewBox="-2 -2 23 23"
    fill="none"
    overflow="visible"
    xmlns="http://www.w3.org/2000/svg"
    className="pointer-events-none absolute top-1/2 z-1 -translate-x-1/2 -translate-y-1/2"
    style={{ left: `${percent * 100}%` }}
    aria-hidden
  >
    <defs>
      <filter
        id="volume-gauge-thumb-shadow"
        x="-50%"
        y="-50%"
        width="200%"
        height="200%"
      >
        <feDropShadow dx="0" dy="0" stdDeviation="1.5" floodOpacity="0.15" />
      </filter>
    </defs>
    <circle
      cx="9.5"
      cy="9.5"
      r="8"
      fill="#FFA400"
      stroke="white"
      strokeWidth="3"
      filter="url(#volume-gauge-thumb-shadow)"
    />
  </svg>
);

export default GaugeThumb;
